import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const slides = [{
  image: 'https://cdn.magicpatterns.com/uploads/kWJwJ7xeoQezuv6RkosBZV/virgen_de_la_paz.jpg',
  title: 'Virgen de la Paz',
  text: 'Uno de los puntos más altos del país, donde el paisaje se abre por completo y la experiencia se siente distinta.'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/i542m78MjdYkUkimPGSkhu/FOTO-2-JGH.jpg',
  title: 'Isnotú — Santuario de José Gregorio Hernández',
  text: 'Un espacio de profunda quietud, donde la tradición y la espiritualidad marcan el ritmo del lugar.'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/h2rm9mbaMUB652isw6gfPF/Laguna_de_Mucubaji,_Merida,_Venezuela.jpg',
  title: 'Laguna de Mucubají',
  text: 'Un entorno de páramo donde el clima, la neblina y el agua crean una experiencia serena y difícil de olvidar.'
}];
export function TrujilloCarousel() {
  const [current, setCurrent] = useState(0);
  const touchStart = useRef<number | null>(null);
  useEffect(() => {
    if (slides.length <= 1) return;
    const timer = setInterval(() => {
      setCurrent(prev => (prev + 1) % slides.length);
    }, 4500);
    return () => clearInterval(timer);
  }, []);
  const handleTouchStart = (e: React.TouchEvent) => {
    touchStart.current = e.touches[0].clientX;
  };
  const handleTouchEnd = (e: React.TouchEvent) => {
    if (touchStart.current === null) return;
    const diff = touchStart.current - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) {
      if (diff > 0) {
        setCurrent(prev => (prev + 1) % slides.length);
      } else {
        setCurrent(prev => (prev - 1 + slides.length) % slides.length);
      }
    }
    touchStart.current = null;
  };
  return <div className="relative w-full h-[55vh] md:h-[75vh] overflow-hidden rounded border-[5px] border-white/90 shadow-[0_2px_20px_rgba(0,0,0,0.06)]" onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd} data-id="element-47">
      {/* Images with fade */}
      {slides.map((slide, idx) => <motion.img key={slide.image} src={slide.image} alt={slide.title} className="absolute inset-0 w-full h-full object-cover" initial={false} animate={{
      opacity: idx === current ? 1 : 0
    }} transition={{
      duration: 1.4,
      ease: [0.25, 0.1, 0.25, 1]
    }} data-id="element-48" />)}

      {/* Gradient overlay for text readability */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/10 to-transparent" data-id="element-49" />

      {/* Text overlay */}
      <AnimatePresence mode="wait" data-id="element-50">
        <motion.div key={current} initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.7,
        ease: [0.25, 0.1, 0.25, 1]
      }} className="absolute bottom-0 left-0 right-0 px-6 pb-10 md:px-14 md:pb-14 text-center" data-id="element-51">
          <p className="font-sans uppercase tracking-[0.3em] text-white/90 text-[11px] md:text-[12px] mb-3" data-id="element-52">
            {'Isnot\xFA \u2014 Santuario de San Jos\xE9 Gregorio Hern\xE1ndez'}
          </p>
          <p className="font-light text-white/80 text-[14px] md:text-[16px] leading-[1.75] max-w-md mx-auto font-[Inter,_sans-serif]" data-id="element-53">
            {slides[current].text}
          </p>
        </motion.div>
      </AnimatePresence>

      {/* Minimal indicators — only show if more than 1 slide */}
      {slides.length > 1 && <div className="absolute bottom-5 right-6 md:bottom-8 md:right-10 flex space-x-3 z-10" data-id="element-54">
          {slides.map((_, idx) => <button key={idx} onClick={() => setCurrent(idx)} className={`h-[1px] transition-all duration-700 ease-in-out ${idx === current ? 'w-10 bg-white' : 'w-5 bg-white/30 hover:bg-white/60'}`} aria-label={`Go to slide ${idx + 1}`} data-id="element-55" />)}
        </div>}
    </div>;
}